module.exports = __webpack_public_path__ + "static/media/exit-full-screen.caf9b27c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/exit-full-screen.svg
// module id = 72
// module chunks = 0